<mat-datepicker #chemotherapyDatePicker></mat-datepicker>
<div [formGroup]="form">
  <ng-container *transloco="let t">
    <div formGroupName="chemotherapyGeneral" class="group-block">
      <h3 class="group-title">{{ t('chemotherapyGeneral') }}</h3>
      <div class="group-inputs">
        <mat-form-field appearance="outline" class="w-full mb-3">
          <mat-label>{{ t('diagnosis') }}</mat-label>
          <input matInput formControlName="diagnosis" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full mb-3">
          <mat-label>{{ t('date') }}</mat-label>
          <input
            matInput
            [matDatepicker]="chemotherapyDatePicker"
            formControlName="date"
            placeholder="dan/mesec/godina"
          
          [min]="minDate" [max]="today"
        />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full mb-3">
          <mat-label>{{ t('veterinarian') }}</mat-label>
          <input matInput formControlName="veterinarian" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full mb-3">
          <mat-label>{{ t('bodyWeightKg') }}</mat-label>
          <input matInput formControlName="bodyWeightKg" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full mb-3">
          <mat-label>{{ t('bodySurfaceM2') }}</mat-label>
          <input matInput formControlName="bodySurfaceM2" />
        </mat-form-field>
      </div>
    </div>

    <div formGroupName="chemotherapyMedication" class="group-block">
      <h3 class="group-title">{{ t('chemotherapyMedication') }}</h3>
      <div class="group-inputs">
        <mat-form-field appearance="outline" class="w-full mb-3">
          <mat-label>{{ t('premedication') }}</mat-label>
          <input matInput formControlName="premedication" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full mb-3">
          <mat-label>{{ t('medicament') }}</mat-label>
          <input matInput formControlName="medicament" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full mb-3">
          <mat-label>{{ t('dose') }}</mat-label>
          <input matInput formControlName="dose" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full mb-3">
          <mat-label>{{ t('administrationMode') }}</mat-label>
          <input matInput formControlName="administrationMode" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full mb-3">
          <mat-label>{{ t('volumeMgH') }}</mat-label>
          <input matInput formControlName="volumeMgH" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full mb-3">
          <mat-label>{{ t('ivCatheter') }}</mat-label>
          <input matInput formControlName="ivCatheter" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full mb-3">
          <mat-label>{{ t('adverseEvents') }}</mat-label>
          <textarea
            matInput
            formControlName="adverseEvents"
            rows="3"
          ></textarea>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full mb-3">
          <mat-label>{{ t('sedationYesNo') }}</mat-label>
          <input matInput formControlName="sedationYesNo" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full mb-3">
          <mat-label>{{ t('sedativeDetails') }}</mat-label>
          <input matInput formControlName="sedativeDetails" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full mb-3">
          <mat-label>{{ t('postTreatment') }}</mat-label>
          <textarea
            matInput
            formControlName="postTreatment"
            rows="3"
          ></textarea>
        </mat-form-field>
      </div>
    </div>

    <div formGroupName="chemotherapyBloodCount" class="group-block">
      <h3 class="group-title">{{ t('chemotherapyBloodCount') }}</h3>
      <div class="group-inputs">
        <mat-form-field appearance="outline" class="w-full mb-3">
          <mat-label>{{ t('wbc') }}</mat-label>
          <input matInput formControlName="wbc" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-full mb-3">
          <mat-label>{{ t('ne') }}</mat-label>
          <input matInput formControlName="ne" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-full mb-3">
          <mat-label>{{ t('rbc') }}</mat-label>
          <input matInput formControlName="rbc" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-full mb-3">
          <mat-label>{{ t('plt') }}</mat-label>
          <input matInput formControlName="plt" />
        </mat-form-field>
      </div>
    </div>

    <div formGroupName="chemotherapyBiochemistry" class="group-block">
      <h3 class="group-title">{{ t('chemotherapyBiochemistry') }}</h3>
      <div class="group-inputs">
        <mat-form-field appearance="outline" class="w-full mb-3">
          <mat-label>{{ t('alt') }}</mat-label>
          <input matInput formControlName="alt" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-full mb-3">
          <mat-label>{{ t('alp') }}</mat-label>
          <input matInput formControlName="alp" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-full mb-3">
          <mat-label>{{ t('ure') }}</mat-label>
          <input matInput formControlName="ure" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-full mb-3">
          <mat-label>{{ t('cre') }}</mat-label>
          <input matInput formControlName="cre" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-full mb-3">
          <mat-label>{{ t('glu') }}</mat-label>
          <input matInput formControlName="glu" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-full mb-3">
          <mat-label>{{ t('tp') }}</mat-label>
          <input matInput formControlName="tp" />
        </mat-form-field>
      </div>
    </div>

    <div formGroupName="chemotherapyVeterinarian" class="group-block">
      <div class="group-inputs">
        <mat-form-field appearance="outline" class="w-full mb-3">
          <mat-label>{{ t('veterinarianName') }}</mat-label>
          <input matInput formControlName="veterinarianName" />
          <mat-error>{{ t('This field is required') }}</mat-error>
        </mat-form-field>
      </div>
    </div>
  </ng-container>
</div>
